<template>
    <div class="form-group">
        <label :for="id">{{ label }}
            <i
                v-if="tooltip"
                v-tooltip.right="tooltip_text"
                style="font-size: 14px;"
                @mouseover="isHovering = true"
                @mouseout="isHovering = false"
                :class="{ 'fas fa-question-circle' : isHovering, 'fal fa-question-circle' : !isHovering}"
            ></i>
        </label>
        <select
            v-if="!loading"
            :id="id"
            :value="value"
            @change="$emit('change', $event.target.value)"
            :name="name"
            :required="required"
            :disabled="disabled"
        >
            <option v-for="(option, index) in options" :disabled="option.disabled" :value="option.value" :key="`${id}-option-${index}`">{{ option.label }}</option>
        </select>
        <div v-if="loading" style="flex: 6; text-align: center;">
            <div class="spinner"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SelectInput',

    data() {
        return {
            isHovering: false,
        };
    },

    props: {
        options: {
            type: Array,
            required: true,
        },

        label: {
            type: String,
            default: '',
        },

        id: {
            type: String,
            required: true,
        },

        value: {
            required: true,
        },

        name: {
            type: String,
        },

        required: {
            type: Boolean,
            default: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        loading: {
            type: Boolean,
            default: false,
        },

        tooltip: {
            type: Boolean,
            default: false,
        },

        tooltip_text: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped>
.form-group {
   display: flex;
   align-items: center;

    label {
        color: $black;
        flex: 2;
    }

    select {
        flex: 6;
        height: 42px;
        font-size: 16px;
        border: 0;
        background-color: white;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        cursor: pointer;
        padding: 0px 16px;
    }
}
.spinner {
    width: 25px;
    height: 25px;
    margin: 8px auto;
    background-color: $yellow;

    border-radius: 100%;
    -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
    animation: sk-scaleout 1.0s infinite ease-in-out;
}

@-webkit-keyframes sk-scaleout {
    0% { -webkit-transform: scale(0) }
    100% {
        -webkit-transform: scale(1.0);
        opacity: 0;
    }
}

@keyframes sk-scaleout {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0);
    } 100% {
          -webkit-transform: scale(1.0);
          transform: scale(1.0);
          opacity: 0;
      }
}
</style>
